<script setup>

const props = defineProps({
  loteStore: Object,
});

const lote = props.loteStore.lote;

</script>

<template>
  <div class="card border-primary mb-3">
    <div class="card-body">
      <i class="fas fa-tag"></i> LOTE {{ lote.codintlote }}
      <div class="mt-3">
        <h5 class="card-title"> {{ lote.titulo }}</h5>
        <p class="card-text text-muted">
          {{ lote.descripcion_completa }}
        </p>
      </div>
    </div>
  </div>

  <div class="card border-primary mb-3">
    <div class="card-body">
      <div class="d-flex">
        <div class="col-9">
          <h5 class="fw-bold"> {{ lote.subasta?.titulo }}</h5>
        </div>
        <div class="col-3">
        </div>
      </div>
      <div class="col-12 align-items-center mt-3 ml-4">
        <p> <i class="far fa-folder"></i> Subasta #{{ lote.subasta?.external_id }} </p>
        <p v-if="lote?.subasta?.aprobacion_tiempo_dias && lote?.subasta?.aprobacion_tiempo_dias > 5"> <i class="far fa-clock"></i> Aprobación {{
          lote?.subasta?.aprobacion_tiempo_dias }} días</p>
        <p v-else-if="lote?.subasta?.aprobacion_tiempo_dias && lote?.subasta?.aprobacion_tiempo_dias <= 5"> <i class="far fa-clock"></i> Aprobación {{
          lote?.subasta?.aprobacion_tiempo_dias * 24 }} horas</p>
        <p v-else><i class="far fa-clock"> </i> Lote de aprobación inmediata</p>
      </div>
    </div>
  </div>
</template>